var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",staticStyle:{"display":"block"},attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('issues-colors',{attrs:{"issuesColors":_vm.$props.issuesSettings.issuesColors}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }